// extracted by mini-css-extract-plugin
export default {"active_tab":"styles_active_tab__f9b1Y","qna":"styles_qna__NKFLA","desktop":"styles_desktop__nLGh4","mobile":"styles_mobile__RNk+U"};